import { makeAutoObservable, observable  } from "mobx";
import { FieldPerformanceService } from "../services/FieldPerformanceService";

class FieldProductionTrendStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedField = { fieldId: "3", fieldName: "AKRI" };
  isIniatilizing = false;
  isLoading = false;
  uniqueFields = [];
  plotData = [];
  isproducing = true;
  isLoadiFields = true;
  async getuniqueFieldsData() {
    try {
      this.isLoadiFields = true;

      const res = await FieldPerformanceService.getuniqueFieldsData(
        this.isproducing
      );
      this.uniqueFields = [...res];
      this.selectedField = res[0];
    } catch (error) {
      throw error;
    } finally {
      this.isLoadiFields = false;
    }
  }
  async getFieldPlotData(fieldId = this.selectedField) {
    try {
      this.isIniatilizing = true;

      const res = await FieldPerformanceService.getFieldPlotData(fieldId);
      this.plotData = [...res];
      console.log("data", res);

      this.isIniatilizing = false;
    } catch (error) {
      throw error;
    } finally {
      this.isIniatilizing = false;
    }
  }
}



const fieldProductionTrendStore = new FieldProductionTrendStore();
export default fieldProductionTrendStore;

